export const colors = {
    iconActiveBackgroundColor: "#e4fafb",
    iconInactiveForegroundColor: "#8ca3b5",
    iconDarkActiveForegroundColor: "#161616",
    iconBrightActiveForegroundColor: "#E06A2B",
}

export const fonts = {
    primaryFontStack: 'Rund, "Century gothic"',
    secondaryFontStack: '"Azeret Mono", "Century gothic"',
    codeFontStack: "monospace",
}
